import React from 'react'
import injectSheet from 'react-jss'
import styles from './sub-head.styles'
import classNames from 'classnames'

const SubHead = ({ classes, children, className, ...props }) => (
  <div className={classNames(classes.container, className)} {...props}>
    {children}
  </div>
)

export default injectSheet(styles)(SubHead)
